import PersonaDeleteModal from './PersonaDeleteModal';

export default PersonaDeleteModal;
